
export enum BolPartyTypeCd {
	BILL_TO = 'BillTo',
	BLIND_SHPR = 'BlindShpr',
	CONS = 'Cons',
	SHPR = 'Shpr',
	TRUE_BLIND_SHPR = 'TrueBlindShpr'}

